module.exports = __webpack_public_path__ + "img/horizontal_3_6_r_pp13_9016.8ac4745f.png";